import React, { ComponentType } from 'react';
import styled from 'styled-components';
import { CategoriesMobileDisplayOption, CategoriesTypeOption, RadiusOption } from 'types/graphql';

import { LargeCard } from 'src/components/categories-nav/cards/large-card';
import { TextCard } from 'src/components/categories-nav/cards/text-card';
import { StackedCard } from 'src/components/categories-nav/cards/stacked-card';
import { CompactCard } from 'src/components/categories-nav/cards/compact-card';
import { CategoriesCarousel } from 'src/components/carousel-v2/types/categories-carousel';
import { GridLayout, CarouselLayout } from './navigation.styles';

type ListProps = {
  children: React.ReactNode;
};

type Category = {
  key: string;
  label: string;
  value: string;
};

type CategoriesListProps = {
  categories: Category[];
  style: RadiusOption;
  type: CategoriesTypeOption;
  mobileDisplay: CategoriesMobileDisplayOption;
};

const getCardComponent = (type: CategoriesTypeOption): ComponentType<any> => {
  switch (type) {
    case CategoriesTypeOption.text:
      return TextCard;
    case CategoriesTypeOption.compact:
      return CompactCard;
    case CategoriesTypeOption.stacked:
      return StackedCard;
    default:
      return LargeCard;
  }
};

export const CategoriesList = ({ categories, style, type, mobileDisplay }: CategoriesListProps): JSX.Element => {
  const CardComponent = getCardComponent(type);
  const isMobileGrid = mobileDisplay === CategoriesMobileDisplayOption.grid;

  return (
    <List>
      {categories.map((category) => (
        <div key={category.key}>
          <CardComponent category={category} style={style} isMobileGrid={isMobileGrid} />
        </div>
      ))}
    </List>
  );
};

const List = ({ children }: ListProps): JSX.Element => (
  <>
    <GridLayout>
      <Grid>{children}</Grid>
    </GridLayout>

    <CarouselLayout>
      <CategoriesCarousel title=''>{children}</CategoriesCarousel>
    </CarouselLayout>
  </>
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 24px;

  & > div > a {
    width: 100%;
    font-size: clamp(16px, 2vw, 18px);
  }
`;
